module.exports = __webpack_public_path__ + "img/logo.f667a894.svg";